import { ModelDescriptor } from '@/app/components/supportTicket/types';
import { cloudApiClient } from '@/services/clientSideCloudApiService';

export async function searchForModels(searchTerm: string) {
  const params = new URLSearchParams({ q: searchTerm });
  return (await cloudApiClient.get(`user/search?${params.toString()}`)).data.data as ModelDescriptor[];
}
